module.exports = __webpack_public_path__ + "media/reskin-images/icon--calendar-mark-cd72be3a.svg";